import React from 'react';
import { ModuleInterface } from '_iae/module/module';
import { NavItem } from 're-cy-cle';
import { t } from 'i18next';
import { CapacityPlannerScreen } from './Screen';

export const capacityPlannerModule: ModuleInterface = {
    name: 'capacityPlanner',
    navigationMenu: () => ({
        basePath: '/planning/capacity-planner/',
        topMenuItem: (
            <NavItem
                title={t('nav.main.capacityPlanner', 'Capacity Planner')}
                to="/planning/capacity-planner"
                activePath="/planning/capacity-planner"
                data-test-nav="capacity-planner"
            />
        ),
        subMenuItems: []
    }),
    routes: [
        {
            path: '/planning/capacity-planner',
            screen: CapacityPlannerScreen
        }
    ],
    translations: {
        en: {},
        nl: {}
    }
};
